module.exports = "/_next/static/resources/life2-871af3c85da8c2bcb5ae5b40da723ce2.jpg";